module.exports = __webpack_public_path__ + "img/screen11@3x.fc136841.jpg";